import { UserData } from "./user-data.interface";

export function createUserData(email = "", password = ""): UserData {
  return {
    email,
    password,
  };
}
